import { useEffect, useMemo, useRef } from "react";
import { useDispatch, useStore } from "react-redux";
import { Widget } from "./Widget.js";

export const useWidgetInitialization = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const initTimer = useRef(null);
  const widget = useMemo(
    () => new Widget(dispatch, store.getState, initTimer),
    [dispatch, store]
  );

  useEffect(() => {
    widget.handleCreateContainer();
    widget.handleToggleContainer();
    widget.handleError();
    widget.handleDispose();
  }, [dispatch, widget]);
};
